import { CSSProperties } from 'react';

export const inputContainerStyle: CSSProperties = {
  position: 'absolute',
  marginTop: '45%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
};

export const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  backgroundColor: 'var(--background-white)',
  height: '100%'
};

export const scrollableListStyle: CSSProperties = {
  width: '100%',
  marginTop: 10,
  maxHeight: 'calc(100vh - 250px - 40px)',
  overflowY: 'auto',
  overscrollBehavior: 'none'
};

export const listItemStyle: CSSProperties = {
  padding: '15px 16px',
  marginRight: '10px',
  marginLeft: '10px',
  marginBottom: '8px',
  borderRadius: '12px',
  cursor: 'pointer',
  fontSize: '15px',
  color: '#1A1A1A',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)'
};

export const selectedItemStyle: CSSProperties = {
  backgroundColor: '#fff',
  border: '2px solid #1A1A1A',
  color: '#1A1A1A'
};

export const selectedItemMarkStyle: CSSProperties = {
  width: '18px',
  height: '18px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '14px',
  fontWeight: '600',
  color: '#fff',
  backgroundColor: '#1A1A1A',
  borderRadius: '50%'
};

export const unselectedItemStyle: CSSProperties = {
  backgroundColor: '#fff',
  border: '2px solid #FFFFFF',
  color: '#1A1A1A'
};
